import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import GenerateCode from '@blade-sxp/portrait-management/components/pass-code/generate.vue';
import ViewCode from '@blade-sxp/portrait-management/components/pass-code/view.vue';
import { generatePassCodeApi, getPassCodeApi } from '@blade-sxp/portrait-management/api/portrait';
let default_1 = class default_1 extends Vue {
    stepKey;
    dialogVisible;
    portraitId;
    codeDate;
    codeForm = {
        date: [],
        totalCount: -1,
        type: 'STATIC',
    };
    codeDetail = {};
    stepsConfig = {
        view: {
            type: 'view',
            width: '36rem',
            height: '56.4rem',
            title: this.$t('viewTlt'),
            confirm: {
                label: this.$t('download'),
                nextStep: '',
                dialogVisible: false,
                hidden: true,
                showTypes: ['STATIC'],
                completed: () => {
                    this.downloadQrCode();
                },
            },
            cancel: {
                label: this.$t('cancelBtn'),
                nextStep: '',
                dialogVisible: false,
                hidden: true,
            },
        },
        add: {
            type: 'add',
            width: '45rem',
            height: '41.6rem',
            title: this.$t('generateTlt'),
            confirm: {
                label: this.$t('generateConfirm'),
                nextStep: 'view',
                dialogVisible: true,
                completed: () => {
                    this.handleRegerate();
                },
            },
            cancel: {
                label: this.$t('cancelBtn'),
                nextStep: '',
                dialogVisible: false,
            },
        },
        edit: {
            type: 'edit',
            width: '45rem',
            height: '41.6rem',
            title: this.$t('generateTlt'),
            confirm: {
                label: this.$t('generateConfirm'),
                nextStep: 'view',
                dialogVisible: true,
                completed: () => {
                    this.handleRegerate();
                },
            },
            cancel: {
                label: this.$t('cancelBtn'),
                nextStep: 'view',
                dialogVisible: true,
            },
        },
    };
    get conputedFooterClazz() {
        return {
            between: this.computedVisibleConfirm && this.computedVisibleCancel,
            empty: !this.computedVisibleConfirm && !this.computedVisibleCancel,
        };
    }
    get computedVisibleConfirm() {
        const target = this.curStep?.confirm;
        const curType = this.codeDetail?.type;
        const hidden = target?.hidden ?? false;
        const isShowType = target?.showTypes?.some?.((i) => i && i === curType) ?? false;
        return hidden ? isShowType : true;
    }
    get computedVisibleCancel() {
        return !this.curStep?.cancel?.hidden;
    }
    get visible() {
        return this.dialogVisible;
    }
    set visible(val) {
        this.$emit('update:dialogVisible', val);
    }
    get curStep() {
        return this.stepsConfig[this.stepKey];
    }
    onCodeDate(nv) {
        if (nv && nv.length > 1) {
            this.codeForm.date = nv;
        }
    }
    onVisible(nv) {
        if (!nv)
            return;
        this.initPassCodeDetail();
    }
    onPortraitId(nv) {
        if (!nv)
            return;
        this.initPassCodeDetail();
    }
    async initPassCodeDetail() {
        this.codeDetail = null;
        const id = this.portraitId;
        if (!id || this.stepKey === 'add')
            return;
        try {
            const res = await getPassCodeApi(id);
            this.updateCodeDetail(res);
        }
        catch (e) {
            console.log(e);
        }
    }
    updateCodeDetail(res) {
        this.codeDetail = res;
        this.codeForm = {
            ...res,
            date: [res.validateStartDate, res.validateEndDate],
        };
        console.log(' this.codeForm', this.codeForm);
    }
    downloadQrCode() {
        this.$refs?.viewCodeRef?.downloadQrCode();
    }
    beforeColse() {
        this.handleCancel();
    }
    handleCancel() {
        const nextStep = this.curStep.cancel?.nextStep;
        nextStep && this.$emit('update:stepKey', nextStep);
        const dialogVisible = this.curStep.cancel?.dialogVisible;
        this.$emit('update:dialogVisible', dialogVisible);
    }
    handleConfirm() {
        const target = this.curStep.confirm;
        const nextStep = target?.nextStep;
        const dialogVisible = target?.dialogVisible;
        const completed = target?.completed;
        completed && completed();
        nextStep && this.$emit('update:stepKey', nextStep);
        this.$emit('update:dialogVisible', dialogVisible);
    }
    handleEdit() {
        console.log('handleEdit');
        this.$emit('update:stepKey', 'edit');
    }
    async handleRegerate() {
        this.codeDetail = null;
        try {
            const param = {
                portraitId: this.portraitId,
                effectiveTimes: this.codeForm?.totalCount ?? -1,
                type: this.codeForm?.type,
            };
            const res = await generatePassCodeApi(param);
            console.log('handleRegerate', res);
            this.updateCodeDetail(res);
        }
        catch (e) {
            console.log(e);
        }
    }
};
__decorate([
    Prop({ default: 'view' })
], default_1.prototype, "stepKey", void 0);
__decorate([
    Prop({ default: false })
], default_1.prototype, "dialogVisible", void 0);
__decorate([
    Prop()
], default_1.prototype, "portraitId", void 0);
__decorate([
    Prop()
], default_1.prototype, "codeDate", void 0);
__decorate([
    Watch('codeDate', { immediate: true, deep: true })
], default_1.prototype, "onCodeDate", null);
__decorate([
    Watch('visible', { immediate: true })
], default_1.prototype, "onVisible", null);
__decorate([
    Watch('portraitId', { immediate: true })
], default_1.prototype, "onPortraitId", null);
default_1 = __decorate([
    Component({
        name: 'passCodeDialog',
        components: { GenerateCode, ViewCode },
        i18n: {
            messages: {
                zh: {
                    viewTlt: '查看通行码',
                    generateTlt: '生成通行码',
                    viewConfirm: '保存',
                    generateConfirm: '生成',
                    cancelBtn: '取消',
                    download: '下载',
                },
                en: {
                    viewTlt: 'Check the pass code',
                    generateTlt: 'Generate a pass code',
                    viewConfirm: 'Save',
                    generateConfirm: 'Generate',
                    cancelBtn: 'Cancel',
                    download: 'Download',
                },
            },
        },
    })
], default_1);
export default default_1;
